import { PureComponent } from "react"

import PagePopup from "../page-popup/page-popup"
import IdeaForm from "../idea-form/idea-form"

import "./add-idea-popup.scss"

class AddIdeaPopup extends PureComponent {
  handleCompleted = (data) => {
    if (this.props.onCreated) this.props.onCreated(data)
    if (this.props.onClose) this.props.onClose()
  }

  render() {
    const { onClose, refetchQueries = [] } = this.props
    return (
      <PagePopup togglePopup={onClose} modifierClass="add-idea">
        <div className="add-idea-popup">
          <div className="add-idea-popup__header">
            <h2 className="add-idea-popup__title">Share your startup idea</h2>
            <p className="add-idea-popup__sub">
              Post your idea so other founders can discover it, comment, and reach out.
            </p>
          </div>
          <IdeaForm
            onCompleted={this.handleCompleted}
            onDiscard={onClose}
            refetchQueries={refetchQueries}
            submitText="Post idea"
            discardText="Cancel"
          />
        </div>
      </PagePopup>
    )
  }
}

export default AddIdeaPopup
